export const NODE_NAME = 'Шина событий';
